import { Button } from 'hem-ui';
import React, { ReactNode } from 'react';

import { Center } from '../Center';
import { SectionTitle } from '../SectionTitle/SectionTitle';
import { Spacer } from '../Spacer';
import { section, wrapper } from './VariantGrid.module.scss';

type VariantGridProps = {
  title?: string;
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4';
  linkLabel?: string;
  linkSlug?: string;
  children: ReactNode;
};

export const VariantGrid: React.FC<VariantGridProps> = ({
  title,
  titleTag = 'h2',
  linkLabel,
  linkSlug,
  children,
}): JSX.Element => (
  <section className={section}>
    {title ? <SectionTitle titleTag={titleTag} title={title} border /> : null}

    <div className={wrapper}>{children}</div>

    {linkLabel && linkSlug ? (
      <>
        <Spacer />
        <Center>
          <Button to={linkSlug}>{linkLabel}</Button>
        </Center>
      </>
    ) : null}
  </section>
);
